<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2022-03-09 13:23:58
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Claim\ClaimType\ClaimType.vue
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_ClaimType_list_title')"
    pad="0"
    :addBtn="hasBtn('add-claim-type')"
    @new="toNew"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :height="$vuetify.breakpoint.height - 275"
        :showSelect="showSelect"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback) => {
            getList(page, perpage, callback);
          }
        "
      >
        <template v-slot:item.name="{ item }">
          {{ $getCommonLangValue(item.claim_type_name) }}
        </template>
        <template v-slot:item.claim_type_code="{ item }">
          {{ $getCommonLangValue(item.claim_type_code) }}
        </template>
        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :delBtn="hasBtn('delete-claim-type')"
            :editBtn="hasBtn('edit-claim-type')"
            :viewBtn="hasBtn('view-claim-type')"
            :title="$t('label_essweb_ClaimType_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
        </template>
      </Tabler>
    </template>
  </ContentLayout>
</template>
<script>
export default {
  name: "ClaimType",
  computed: {},
  data() {
    return {
      showSelect: false,
      selected: [],
      search: "",
      totalCount: 0,
      headers: [
        {
          text: "label_essweb_ClaimType_list_claimTypeLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimType_form_claimTypeCodeLabel",
          value: "claim_type_code",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    getList: function (page, perpage, callback) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_claim_claim_type",
        url: "/claim-type/get-claim-type-list/",
        data: { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback() : null;
      });
    },
    toNew: function () {
      this.$toPage("/admin/claim-type/add", {});
    },
    toEdit: function (uuid, action) {
      this.$toPage(
        (action == "edit"
          ? "/admin/claim-type/edit/"
          : "/admin/claim-type/detail/") + uuid
      );
    },
    toDelete: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_claim_claim_type",
        url: "/claim-type/delete-claim-type-table/",
        data: { uuids: uuid },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_ClaimType_list_deleteClaimTypeSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== uuid);
      });
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
  },
};
</script>
